import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '.';

export const appSlice = createSlice({
  name: 'app',
  initialState: {
    flow: null,
    timerSeconds: null,
    darkMode: false,
    showCookieBanner: true,
  },
  reducers: {
    setFlow: (state, action) => {
      state.flow = action.payload;
    },
    setTimerSeconds: (state, action) => {
      state.timerSeconds = action.payload;
    },
    setDarkMode: (state, action) => {
      state.darkMode = action.payload;
    },
    setShowCookieBanner: (state, action: PayloadAction<boolean>) => {
      state.showCookieBanner = action.payload;
    },
  },
});

export const { setFlow, setTimerSeconds, setDarkMode, setShowCookieBanner } = appSlice.actions;

export const selectFlow = (state: any) => state.app.flow;
export const selectTimerSeconds = (state: any) => state.app.timerSeconds;
export const selectDarkMode = (state: any) => state.app.darkMode;
export const selectShowCookieBanner = (state: RootState) => state.app.showCookieBanner;

export default appSlice.reducer;
